import { Stack } from '@mui/material';
import RegisterButton from '../atoms/RegisterButton';
import SignInButton from '../atoms/SignInButton';
import useDisplayContentConfig from '../../hooks/useDisplayContentConfig';

const AuthButtons = () => {
  const { isEndUserMode, isModernBranding } = useDisplayContentConfig();
  const direction = isModernBranding ? 'row' : 'row-reverse';

  return (
    <Stack
      spacing={1}
      direction={direction}
      sx={{
        alignItems: 'center',
      }}
    >
      <SignInButton />
      {isEndUserMode && <RegisterButton />}
    </Stack>
  );
};

export default AuthButtons;
